import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { MatListModule } from '@angular/material/list'
import { LangSelectorComponent } from '@app/shared/lang-selector/components/lang-selector.component'
import { ClickOutsideDirective } from './directives/click-outside.directive'

@NgModule({
  imports: [
    CommonModule,

    // Material
    MatIconModule,
    MatListModule
  ],
  declarations: [LangSelectorComponent, ClickOutsideDirective],
  exports: [LangSelectorComponent]
})
export class LangSelectorModule {}
